import { regexConstants, errorMsg1 } from '../../../constants/regEx';
export const addEolObligation = {
  reserve_account: null,
  compensation_base: null,
  compensation_type:null,
  compensation_time:null,
  excess_refund:null,
	remarks: ''
}
export const eolObligationHd = [
  { label: 'Event', sortOption: false },
  { label: 'Excess Refund', sortOption: false },
  { label: 'Compensation Time', sortOption: false },
  { label: 'Compensation Type', sortOption: false },
  { label: 'Compensation Base', sortOption: false },
  // { label: 'Remarks', sortOption: false },
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action(s)', sortOption: false , actionCell:'right'}
]

export const errorCode = {
  event:{
    0:'',
    1: 'Please select Event'
  },
  eventObj: {
    required: true
  },
}
